class EstimatedDeliveryDate extends HTMLElement {
    constructor() {
        super();
        this.timeElement = this.querySelector(`[data-date]`);
    }

    connectedCallback() {
        let currentDate = new Date();
        currentDate.setMonth(currentDate.getMonth() + 1);

        let formattedDated =
            currentDate.getDate().toString().padStart(2, '0') +
            '/' +
            (currentDate.getMonth() + 1).toString().padStart(2, '0') +
            '/' +
            currentDate.getFullYear();
        if (this.timeElement) {
            this.timeElement.textContent = formattedDated;
        }
    }
}

customElements.define('estimated-delivery-date', EstimatedDeliveryDate);
